export class Pagination {
  offset: number;
  limit: number;
  sortCriteria: SortCriterion[];
  conditionalCriteria: ConditionalCriterion[];
  snapshot: string;

  constructor(
    theOffset?: number,
    theLimit?: number,
    theConditions?: ConditionalCriterion[],
    theSort?: SortCriterion[],
    theSnapshot?: string
  ) {
    this.offset = theOffset ? theOffset : 0;
    this.limit = theLimit ? theLimit : 100;
    this.sortCriteria = theSort ? theSort : [];
    this.conditionalCriteria = theConditions ? theConditions : [];
    this.snapshot = theSnapshot ? theSnapshot : null;
  }

  public getPageSize() {
    return this.limit;
  }

  public getPageIndex(/* pages start from zero */) {
    return Math.round(Math.floor(this.offset / this.limit));
  }

  public setPageIndex(pageFromZero: number /* pages start from zero*/) {
    this.offset = this.limit * pageFromZero;
  }

  public getSnapshot(/* pages start from null snapshot string */) {
    return this.snapshot;
  }

  public setSnapshot(snapshot: string /* pages start null snapshot string*/) {
    this.snapshot = snapshot;
  }

  getQueryKeyValues() {
    let buffer = String('');
    for (let a = 0; a < this.conditionalCriteria.length; a++) {
      if (a > 0) {
        buffer = buffer + '&';
      }
      buffer +=
        this.conditionalCriteria[a].columnName +
        this.conditionalCriteria[a].operator +
        this.conditionalCriteria[a].value;
    }
    for (let a = 0; a < this.sortCriteria.length; a++) {
      if (a > 0 || this.conditionalCriteria.length > 0) {
        buffer = buffer + '&';
      }
      buffer +=
        this.sortCriteria[a].columnName + '=' + this.sortCriteria[a].value;
    }
    buffer = buffer + '&limit=' + Math.round(this.limit);
    buffer = buffer + '&offset=' + Math.round(this.offset);

    if (this.snapshot){ buffer = buffer + '&snapshot=' + this.snapshot; }

    return buffer;
  }
}

export class SortCriterion {
  columnName: string;
  value: string;
}

export class ConditionalCriterion {
  columnName: string;
  operator: string;
  value: string;
}

//ARAP_Type
